import { render, staticRenderFns } from "./CAlert.vue?vue&type=template&id=5d7e466c&"
import script from "./CAlert.vue?vue&type=script&lang=js&"
export * from "./CAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports